<template>
  <div>
    <div class="row">
      <div class="col-sm-6">
        <div class="form-group has-label">
          <label>Zeitraum</label>
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="Bis"
            start-placeholder="Anfangsdatum"
            end-placeholder="Enddatum"
            format="dd.MM.yyyy"
            value-format="yyyy-MM-dd"
            @change="fetchTableData"
            :picker-options="{ firstDayOfWeek: 1 }"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6" v-if="productCategories.length > 0">
        <div class="form-group has-label">
          <label>Warengruppen</label>
          <multiselect v-model="selectedProductCategories"
            :multiple="true"
            :options="productCategories"
            track-by="id"
            label="name"
            @input="fetchTableData"
          />
        </div>
      </div>
    </div>
    <div class="row" v-if="false">
      <div class="col-sm-6">
        <product-select
          v-model="product"
          @input="fetchTableData"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <div class="form-group has-label">
          <label>Ansicht kumuliert nach</label>
          <div>
              <l-radio v-model="viewType" @input="fetchTableData" inline label="variation">Variationen</l-radio>
              <l-radio v-model="viewType" @input="fetchTableData" inline label="product">Produkte</l-radio>
          </div>
        </div>
      </div>
    </div>
    <revenue-table
      :stock-rotations="stockRotations"
      :loading="loading"
      :view-type="viewType"
      @openVariations="openVariations"
    />
    <product-variations-revenue-dialog
      :variations="productVariations"
      :show="showDialog"
      @close="showDialog = false"
    />
  </div>
</template>

<script>
import { DatePicker } from 'element-ui'
import moment from 'moment'
import RevenueTable from './revenue-table'
import ProductVariationsRevenueDialog from './product-variations-revenue-dialog'
import { groupNewestSuppliers } from 'src/util/helpers'
import ProductSelect from 'src/components/product-select'
import { Radio as LRadio } from 'src/components'

export default {
  components: {
    LRadio,
    RevenueTable,
    ProductSelect,
    [DatePicker.name]: DatePicker,
    ProductVariationsRevenueDialog
  },
  data () {
    return {
      dateRange: [
        moment().startOf('month').format('YYYY-MM-DD'),
        moment().endOf('month').format('YYYY-MM-DD')
      ],
      stockRotations: [],
      productCategories: [],
      selectedProductCategories: [],
      product: null,
      loading: true,
      viewType: 'variation',
      productVariations: [],
      showDialog: false
    }
  },
  methods: {
    fetchTableData () {
      this.loading = true

      const dateRangeFilter = this.dateRange ? encodeURIComponent(this.dateRange) : ''
      const productCategories = this.selectedProductCategories.length ? encodeURIComponent(this.selectedProductCategories.map(pc => pc.id)) : ''
      const product = this.product ? this.product.id : ''

      this.$http.get(`/revenue?date_range=${dateRangeFilter}&product_categories=${productCategories}&product=${product}&view_type=${this.viewType}`).then(({ data }) => {
        this.stockRotations = data.map(stockRotation => {
          const productSuppliers = groupNewestSuppliers(stockRotation.product_instance.product.suppliers)
          const cheapestSupplier = productSuppliers.length ? productSuppliers[0].price : ''
          return { ...stockRotation, cheapestSupplier }
        })
        this.loading = false
      })
    },
    openVariations (stockRotation) {
      const dateRangeFilter = this.dateRange ? encodeURIComponent(this.dateRange) : ''
      const productCategories = this.selectedProductCategories.length ? encodeURIComponent(this.selectedProductCategories.map(pc => pc.id)) : ''
      const product = stockRotation.accumulated_id

      const url = `/revenue?date_range=${dateRangeFilter}&product_categories=${productCategories}&product=${product}&view_type=variation`
      this.$http.get(url).then(({ data }) => {
        this.productVariations = data
        this.showDialog = true
      })
    }
  },
  created () {
    this.fetchTableData()
    this.$http.get('/product_categories').then(({ data }) => { this.productCategories = data })
  }
}
</script>
